import React, { Component, Fragment } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../../../hoc/Loading/Loading';
import axios from '../../../../axios';
import * as actionCreators from '../../../../modules/actions/index';
import { connect } from 'react-redux';
import moment from 'moment';
import * as url from '../../../../utils/url';
import { Card, CardBody, CardImg, CardTitle, CardText, Button,Input, Row, Col, Modal } from "reactstrap";
import Insight from './SingleReport';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import UploadReport from '../../../../assets/placeholders/reports_icon.png';
import UploadReport from '../../../../assets/placeholders/kpi_available.svg';
import { Link } from 'react-router-dom';
import ReportLayout from './ReportLayout';

class DashboardReports extends Component {

    // childRef = React.createRef()
    childInsightRef = React.createRef();     

  constructor(props) {
    super(props);
    this.state = { 
        startDate:null,
        isExpanded:{},
        actionType:null,
        isSelected:null,
        dateRange:null,
        endDate:moment(new Date()),
        insights: this.props.insights? this.props.insights:[],
        singleNote:{},
        openCreateChartReport:false,
     }
  }

  openCreateChartReport=()=>{
    this.setState( prevState =>({ openCreateChartReport: !prevState.openCreateChartReport }))
  }


  completeAddedInsight=(insights, type)=>{
    let{actionType,openCreateChartReport}=this.state,
    update={openCreateChartReport: !openCreateChartReport}
    console.log('type: ', type)
    if(type=="R"){
      this.setState( prevState =>({ 
        // openCreateChartReport: !prevState.openCreateChartReport, 
        insights
      }))
    } else {
      if(actionType!='VIEW'){
        update = {...update, insights}
      }
      this.setState( prevState =>({
        openCreateChartReport: !prevState.openCreateChartReport,
        insights: actionType!='VIEW'?insights: prevState.insights
        }))
    }
  }

  componentDidMount(){
    // this.getAttachedItems()
    // axios.post(url.getDashboardList, {organizationId:organizationId._id, isEditOnly:true}).then((response) => {
    //   let list = response.data.data.map(e=>{
    //     return {id: e._id , name: e.name}
    //   })
    //   this.setState({dashboardOptions: list})
    // }).catch((error) => { console.log(error) });
  }
  
  componentDidUpdate(prevProps) {
  }

    handleChangeText = (event) => {
        const descriptionContext = event.editor.getData();
        let{singleNote}=this.state
        // console.log(task.description)
        singleNote = {...singleNote, description:descriptionContext }
        this.setState({ singleNote })
    }

 
  
    viewInsight = (itm, type) =>{
      this.setState({isExpanded: itm, 
        openCreateChartReport:true,
        actionType: type
        // insights:result
      })
    }


    removeChartInsight=(insight)=>{
      let that=this
      let{chart}=this.props

      console.log(insight, '-------',chart)
      let payload= {
        dashboardId: insight.dashboardId,
        chartId:insight.chartId,
        insightId: insight._id
      }
      axios.post(url.removeChartInsight, payload).then(({ data }) => {
        that.props.updateReportCharts(data.data)
        that.completeAddedInsight(data.data.insights, "R")
      })
      
    }

  renderView=()=>{
    let{insights, actionType,openCreateChartReport,isExpanded}=this.state
        if(!openCreateChartReport &&insights && insights.length>0){
            return(
                insights.map( (e,idx) =>{
                  let name = e.name && e.name!=""?e.name: false
                    // let{size,url}=e
                    // let img = uploadPreview(e)
                    // let{preview, isMsIcon}=img
                    // let mb = 1024*1024
                    // let file_size = size>= mb? `${(size/mb).toFixed(2)}mb`:`${(size/1024).toFixed(2)}kb` 
                      console.log(e.isHidden)
                    return (
                        <div className={e.isHidden?'hide':'col-lg-2 insightsItmContainer'}
                        key={idx+e.timestamp}>
                        <Card className="taskAttachmentItmContainer">
                            {/* <span className="taskAttachmentImgContainer">
                            <CardImg
                            alt="..."
                            src={preview}
                            top
                            className="taskAttachmentImg"
                            style={{'height': isMsIcon?'5vw': null}}
                            ></CardImg>
                            </span> */}
                            <CardBody className="uploadTaskContainer">
                            {name?<CardTitle className="taskAttachmentName">{name}</CardTitle>:
                            <CardTitle className="taskAttachmentName"> {moment(e.timestamp).format("MMM YYYY")} Insights </CardTitle>}
                            <div className="ml0">

                                {/* <span className="insightsItmTxt"  dangerouslySetInnerHTML={this.createMarkup(e.description)} /> */}
                                <span className="taskAttachmentContent text-muted">
                                 {moment(e.timestamp).format("MMM D, YYYY h:mm a")}
                                </span>

                                <span className="taskAttachmentContent text-muted">
                                 {e.firstname} {e.lastname}
                                </span>

                                <span className="insightsItmOptionsContainer">
                                <span className="insightsItmViewOption" onClick={()=>this.viewInsight(e, "VIEW")}>View<i className='flaticon-vision'/></span>
                                &nbsp; | &nbsp;
                                <span className="insightsItmRemoveOption"  onClick={()=>this.removeChartInsight(e)}>
                                Remove<i className='flaticon-trash'/>
                                </span>
                                </span>
                              
                            </div>
                            </CardBody>
                        </Card>
                        </div>           
                    )
                })
            )
        } else if(!openCreateChartReport &&insights && insights.length==0){
            return (
                <div className="noDashboardReportContainer col-lg-6 col-md-6 col-sm-6"  onClick={()=>this.openCreateChartReport()}> 
                    {/* <img src={noInsightIcon} className="noChartInsightsImg"/> */}
                    <img src={UploadReport} className="noReportsImg"/>
                        {/* <svg xmlns="http://www.w3.org/2000/svg" 
                        className="noChartInsightsImg"
                        // width="16" height="16"
                         fill="currentColor" 
                                viewBox="0 0 16 16">
                                    <path d="M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
                                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                        </svg> */}
                   <span className='noReportsImgTxt'> To create a report, please click here  </span>
                </div>
            )
        } else if(openCreateChartReport) {
          return(
            <div className="singleDashboardComponentContainer"
            // style={{'margin': actionType=='VIEW'?'auto':'initial'}}
            style={{'margin': 'auto'}}
            >
                <Insight 
                closeAddInsight={this.completeAddedInsight}
                chart={this.props.chart} 
                actionType={actionType}            
                selectedInsight = {this.state.isExpanded}
                insight_idx = {insights && insights.length>0?insights.length:0}
                closeSingleInsight={this.openCreateChartReport}
                changeInsightAction={this.changeInsightAction}
                openCreateChartReport={openCreateChartReport}/>
            </div>
          )
        } 
  }


  changeInsightAction=val=>{

    let obj={actionType:val}
   
    if(val=='CREATE'){
      obj= {...obj,
        isExpanded:{},
        singleNote:{}
      }
    }
   this.setState(obj)
  }

applyDateFilter = (type) =>{
    let{startDate,endDate,insights}=this.state, res

    let filter ={
      chartId: this.props.chart._id,
      dashboardId: this.props.reports._id
    }

    
  if(type!='clear'){
     res = insights.map(e=> {
      if (!moment(e.timestamp).isBetween(moment(startDate),moment(endDate))) {
        e={...e, isHidden:true}
      }
      return e
    })
  } else {
    res = insights.map(e=> {
      delete e.isHidden
      return e
    })
  }

  this.setState({insights:res})

    // axios
}  

  handleEndDateChange = date => {
    if(!date){
      return
    }
    if (this.state.startDate!=null && date < this.state.startDate) {
      this.setState({
        endDate: this.state.startDate,
        error: false
      });
    } else {
      this.setState({
        endDate: date,
        error: false
      });
    }
  };

  handleStartDateChange = date => {
    // console.log(date)

    if(!date){
      return
    }

    if (this.state.endDate!==null && date > this.state.endDate) {
      this.setState({
        startDate: this.state.endDate,
        error: false
      });
    } else {
      this.setState({
        startDate: date,
        error: false
      });
    }
  };


setDateRange=(date)=>{
  console.log('date : ', date)
  this.setState({dateRange:date})
  // this.setState({start})
}

openDatePicker = (id) => {
  document.getElementById(id).click();
};
 

  renderDatePicker =()=>{
      let{endDate,startDate}=this.state
    return (
      <span className="dateFilterContainer">

        <div className="inner-addon right-addon dateFilterPicker insightsDateFilterPicker">
            <span className="chart-reports-datepicker flaticon-calendar" onClick={() => this.openDatePicker('startDatePicker')} />
            <DatePicker
            id="startDatePicker"
                className="chartViewReportsDatePicker"
                placeholderText="Select a start date"
                selected={startDate}
                onChange={this.handleStartDateChange} 
                selectsStart
                showYearDropdown
                startDate={moment()}
                endDate={endDate}
                maxDate={this.state.endDate?moment(this.state.endDate):moment(new Date())}
                id="startDatePicker"
                // dateFormat="MM/yyyy"
            />
        </div>
       
        <span className="mg10">to</span>
       
        <div className="inner-addon right-addon dateFilterPicker">
            <span className="chart-reports-datepicker">
              <span className="flaticon-calendar" onClick={() => this.openDatePicker('endDatePicker')} />
            </span>
            <DatePicker
            id="endDatePicker"
                className="chartViewReportsDatePicker"
                selected={moment(endDate)}
                onChange={this.handleEndDateChange} 
                selectsEnd
                showYearDropdown
                startDate={moment(startDate)}
                endDate={moment(endDate)}
                maxDate={moment(new Date())} 
                disabled={!this.state.startDate} 
                id="endDatePicker"
            />
        </div>

         { startDate? <Button outline color="info" className="chartViewReportsDatePickerBtn" onClick={()=>this.applyDateFilter()}> Apply </Button>:null}
         { startDate? <Button outline color="secondary" className="chartViewReportsDatePickerBtn" onClick={()=>this.applyDateFilter('clear')}> Clear </Button>:null}

    </span>
    )
}

createMarkup = (input) => {
  return { __html: `<div>${input}</div>` };
}


createNewInsight=()=>{
  this.setState( prevState =>({ openCreateChartReport: !prevState.openCreateChartReport, 
    singleNote: {},
    isExpanded:{},
    actionType:'CREATE' }))
}

previewReport=()=>{
  this.setState({isPreviewReport:true})
  // http://localhost:3000/home/dashboard/5c421da6363d02090ea4b9aa/view/61f38f6396936c4f90b9e29c?o=5c421da6363d02090ea4b9aa
  // this.props.history.push(`/home/dashboard/${this.props.user.profile.organizationId._id}/report-preview/${this.props.reports._id}`)
}

closeReport=()=>{
  this.setState({isPreviewReport:false})
}

  render() { 
      let{insights, openCreateChartReport,actionType, isPreviewReport}=this.state
    return  <div className="card-deck dashboardInsightsContainer" >
      <div className="dashboardInsightsTitleContainer">Reports</div>
      {openCreateChartReport?
      // <Link to={`/home/dashboard/${this.props.user.profile.organizationId._id}/report-preview/${this.props.reports._id}`} 
      // className="singleReportsPreview" target="_blank">
      //   Preview Report
      // </Link>
      <span className="singleReportsPreview" onClick={()=>this.previewReport()}> Preview Report </span>
      :null}
      <span className={!openCreateChartReport?"chartViewReportsLabelTxt": 'chartViewReportsBtnLabel cancelCreateInsight'}>  


        {!openCreateChartReport?
         <span className="chartViewReportsBtn btn btn-primary"
            onClick={()=>this.createNewInsight()}>
            <span className="chartViewReportsBtnLabel">Add report
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg>
            </span>
            </span>
        :null
        }


        { !openCreateChartReport&&insights && insights.length>0?
        this.renderDatePicker():null}
      </span>

      
      {this.renderView()}
       




        {isPreviewReport?
        <Modal isOpen={isPreviewReport} className="isPreviewReportModal">
          <ReportLayout closeReport={this.closeReport} />
        </Modal>
        :null}







      </div>
        
  }
}




const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports:state.reports
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReportCharts:(dashboard)=> dispatch(actionCreators.updateReportCharts(dashboard)),
  }
}
 
// export default LinkedCharts;
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(DashboardReports, axios)));